import React from "react";
import Style from "./Footer.module.css"
import footerLogo from "../../Assets/footerlogo.png";
export default function Footer() {
  return (
    <>
       
    </>
  );
}
